import DropDown from './dropdown';

export default class PillDescription {
  constructor(container) {
    this.container = container;
    this.dropdown = container.querySelector('.js-dropdown');
    this.button = container.querySelector('.js-button');
    this.pane = container.querySelector('.js-pane');

    if (!this.dropdown || !this.button || !this.pane) return;

    this.instance = new DropDown(this.dropdown, {
      button: this.button,
      pane: this.pane,
      isOpen: false,
      clickOutside: true,
    });
  }
}
